import themeGet from "@styled-system/theme-get";
import styled from "styled-components";
import { Box } from "orcs-design-system";

export const StyledForm = styled(Box)`
  background: ${(props) =>
    props.highlight ? themeGet("colors.primary10")(props) : "none"};
  margin-top: ${(props) =>
    props.highlight ? themeGet("space.s")(props) : "0"};
`;
